import React from 'react';
import './about-us.scss';
import Breadcrumb from 'shared/breadcrumb/breadcrumb.js';
import ResponsiveImage from 'shared/responsive-image/responsive-image';
import { useStore } from 'hooks/useStore';

export function AboutUs() {
  const {
    state: {
      aboutUs: {
        contacts
      }
    }
  } = useStore();

  return (
    <main>
      <Breadcrumb
        links={[
          { to: '/', text: 'Главная' },
          { to: '/about-us', text: 'О нас' }
        ]}
      />
      {/* /breadcrumb */}

      <div className="container margin_60">
        <div className="main_title">
          <h1>О нас</h1>
        </div>
        <div>
          <div className="card add_bottom_45">
            <div className="card-body">
              <div className="all-contacts clearfix">
                <ResponsiveImage
                  src="/v1555154910/home/pdsm-side2019.jpg"
                  className="img-fluid img-thumbnail add_bottom_15 add_right_15 float-start"
                  alt="pdsm"
                  width={6000}
                  height={4000}
                />
                <h2 className="add_bottom_30">Контакты</h2>
                {contacts.map((contact, index) => (
                  <address className="float-start" key={index}>
                    <i className={contact.iconClass} />
                    <strong> {contact.label}</strong>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: contact.content
                      }}
                    />
                  </address>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default AboutUs;
